export default __webpack_public_path__ + "static/media/expandIcon.94ee70eb.svg";